import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { contactUsAsync } from './index';

const initialState = {
    isContactUsLoading: false,
    isError: false,
}

const contactUsSlice = createSlice({
    name: 'contactUs',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(contactUsAsync.pending, (state) => {
                state.isContactUsLoading = true;
            })
            .addCase(contactUsAsync.fulfilled, (state, { payload }) => {
                state.isContactUsLoading = false;
            })
            .addCase(contactUsAsync.rejected, (state) => {
                state.isContactUsLoading = false;
                state.isError = false;
                if (window.location.hostname !== 'localhost') {
                    window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                }
            })
    },
});

export const getAllContactUs = (state) => state.contactUs;

export default contactUsSlice.reducer;
